export default __webpack_public_path__ + "static/media/puzzle-piece-simple-solid.39d45ec0.svg";